import React from 'react'
import { Outlet } from 'react-router-dom'

function FreeLayout() {
    return (
        <>
            <Outlet/>
        </>
        
    )
}

export default FreeLayout